import { defineComponent as _defineComponent } from 'vue'
import NotificationPanelItemGroups from '@/components/toolbar/notification/NotificationPanelItemGroups.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import { computed } from 'vue';
import useNotificationState from '@/state/notificationState';
import {
  NotificationCounts, NotificationPanelGroup, NotificationType, NotificationCountType, NotificationListItem
} from '@/models/Notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanel',
  setup(__props) {

const { isSmartphoneWidth } = useResponsiveness();

const {
  notifications, which, panelPos
} = useNotificationState();

const style = computed(() => {
  if (isSmartphoneWidth.value) {
    return {
      left: `${25 + panelPos.value * 50}%`,
    };
  }
  return null;
});

const createGroup = (obj?: NotificationCounts, label?: string, itemKeys?: NotificationCountType[]): NotificationPanelGroup => {
  if (!obj) {
    return {
      items: []
    };
  }

  if (!itemKeys) itemKeys = Object.keys(obj) as NotificationCountType[];

  const items: NotificationListItem[] = itemKeys.filter(
    (itemKey) => !!obj?.[itemKey]
  ).map(
    (itemKey) => ({
      count: obj?.[itemKey] ?? 0,
      countType: itemKey as NotificationCountType,
    })
  );

  return {
    label,
    items
  };
};

const projectGroups = computed(() => ({
  notificationType: NotificationType.Projects,
  groups: [
    createGroup(notifications.value?.[NotificationType.Projects], 'projects', [
      NotificationCountType.NewProjectChanges,
      NotificationCountType.NewProjectComments,
      NotificationCountType.NewProjects
    ]),
    createGroup(notifications.value?.[NotificationType.Projects], 'recommendations', [
      NotificationCountType.NewRecommendations,
      NotificationCountType.NewRecommendationFeedbacks
    ]),
    createGroup(notifications.value?.[NotificationType.Projects], 'projectOffers', [
      NotificationCountType.NewProjectOffers,
      NotificationCountType.ChangedProjectOffers
    ]),
  ].filter((group) => !!group.items.length)
}));

const talkGroups = computed(() => ({
  notificationType: NotificationType.Talks,
  groups: [
    createGroup(notifications.value?.[NotificationType.Talks])
  ]
}));

const messageGroups = computed(() => ({
  notificationType: NotificationType.Messages,
  groups: [
    createGroup(notifications.value?.[NotificationType.Messages])
  ]
}));

const contractGroups = computed(() => ({
  notificationType: NotificationType.Contracts,
  groups: [
    createGroup(notifications.value?.[NotificationType.Contracts])
  ]
}));
const invoiceGroups = computed(() => ({
  notificationType: NotificationType.Invoices,
  groups: [
    createGroup(notifications.value?.[NotificationType.Invoices])
  ]
}));

const meetingGroups = computed(() => ({
  notificationType: NotificationType.Meetings,
  groups: [
    createGroup(notifications.value?.[NotificationType.Meetings])
  ]
}));

const panelGroups = computed(() => {
  switch (which.value) {
    case NotificationType.Projects: return [projectGroups.value];
    case NotificationType.Talks: return [talkGroups.value];
    case NotificationType.Messages: return [messageGroups.value];
    case NotificationType.Contracts: return [contractGroups.value];
    case NotificationType.Invoices: return [invoiceGroups.value];
    case NotificationType.Meetings: return [meetingGroups.value];
  }
  return [
    projectGroups.value, talkGroups.value, messageGroups.value, contractGroups.value, invoiceGroups.value, meetingGroups.value
  ].filter(
    (groups) => !!groups.groups.reduce((prev, cur) => prev + cur.items.length, 0)
  );
});


return { __sfc: true,isSmartphoneWidth, notifications, which, panelPos, style, createGroup, projectGroups, talkGroups, messageGroups, contractGroups, invoiceGroups, meetingGroups, panelGroups, NotificationPanelItemGroups }
}

})